import "./Footer.scss";

function Footer() {
  const social = [
    {
      id: "linkdin",
      icon: (
        <svg
          width="20"
          height="18"
          viewBox="0 0 20 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.94 2.00002C4.93974 2.53046 4.72877 3.03906 4.35351 3.41394C3.97825 3.78883 3.46944 3.99929 2.939 3.99902C2.40857 3.99876 1.89997 3.78779 1.52508 3.41253C1.1502 3.03727 0.939737 2.52846 0.940003 1.99802C0.940268 1.46759 1.15124 0.958988 1.5265 0.584103C1.90176 0.209218 2.41057 -0.00124153 2.941 -0.000976312C3.47144 -0.000711096 3.98004 0.210257 4.35492 0.585517C4.72981 0.960777 4.94027 1.46959 4.94 2.00002V2.00002ZM5 5.48002H1V18H5V5.48002ZM11.32 5.48002H7.34V18H11.28V11.43C11.28 7.77002 16.05 7.43002 16.05 11.43V18H20V10.07C20 3.90002 12.94 4.13002 11.28 7.16002L11.32 5.48002V5.48002Z"
            fill="#607B96"
          />
        </svg>
      ),
      url: "https://www.linkedin.com/in/hamza-rihani/",
    },
    {
      id: "twiter",
      icon: (
        <svg
          width="22"
          height="18"
          viewBox="0 0 22 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.162 2.65593C20.3986 2.99362 19.589 3.2154 18.76 3.31393C19.6338 2.79136 20.2877 1.96894 20.6 0.999927C19.78 1.48793 18.881 1.82993 17.944 2.01493C17.3146 1.34151 16.4804 0.89489 15.571 0.744511C14.6615 0.594133 13.7279 0.748418 12.9153 1.18338C12.1026 1.61834 11.4564 2.30961 11.0771 3.14972C10.6978 3.98983 10.6067 4.93171 10.818 5.82893C9.15511 5.74558 7.52833 5.31345 6.04329 4.56059C4.55824 3.80773 3.24813 2.75097 2.198 1.45893C1.82629 2.09738 1.63095 2.82315 1.632 3.56193C1.632 5.01193 2.37 6.29293 3.492 7.04293C2.82801 7.02202 2.17863 6.84271 1.598 6.51993V6.57193C1.5982 7.53763 1.93237 8.47354 2.54385 9.22099C3.15533 9.96843 4.00648 10.4814 4.953 10.6729C4.33661 10.84 3.69031 10.8646 3.063 10.7449C3.32987 11.5762 3.85001 12.3031 4.55059 12.824C5.25118 13.3449 6.09713 13.6337 6.97 13.6499C6.10248 14.3313 5.10918 14.8349 4.04688 15.1321C2.98458 15.4293 1.87413 15.5142 0.778999 15.3819C2.6907 16.6114 4.9161 17.264 7.189 17.2619C14.882 17.2619 19.089 10.8889 19.089 5.36193C19.089 5.18193 19.084 4.99993 19.076 4.82193C19.8949 4.23009 20.6016 3.49695 21.163 2.65693L21.162 2.65593Z"
            fill="#607B96"
          />
        </svg>
      ),
      url: "https://twitter.com/hamzarihani66",
    },
    {
      id: "instagram",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 0C12.717 0 13.056 0.00999994 14.122 0.0599999C15.187 0.11 15.912 0.277 16.55 0.525C17.21 0.779 17.766 1.123 18.322 1.678C18.8305 2.1779 19.224 2.78259 19.475 3.45C19.722 4.087 19.89 4.813 19.94 5.878C19.987 6.944 20 7.283 20 10C20 12.717 19.99 13.056 19.94 14.122C19.89 15.187 19.722 15.912 19.475 16.55C19.2247 17.2178 18.8311 17.8226 18.322 18.322C17.822 18.8303 17.2173 19.2238 16.55 19.475C15.913 19.722 15.187 19.89 14.122 19.94C13.056 19.987 12.717 20 10 20C7.283 20 6.944 19.99 5.878 19.94C4.813 19.89 4.088 19.722 3.45 19.475C2.78233 19.2245 2.17753 18.8309 1.678 18.322C1.16941 17.8222 0.775931 17.2175 0.525 16.55C0.277 15.913 0.11 15.187 0.0599999 14.122C0.0129999 13.056 0 12.717 0 10C0 7.283 0.00999994 6.944 0.0599999 5.878C0.11 4.812 0.277 4.088 0.525 3.45C0.775236 2.78218 1.1688 2.17732 1.678 1.678C2.17767 1.16923 2.78243 0.775729 3.45 0.525C4.088 0.277 4.812 0.11 5.878 0.0599999C6.944 0.0129999 7.283 0 10 0ZM10 5C8.67392 5 7.40215 5.52678 6.46447 6.46447C5.52678 7.40215 5 8.67392 5 10C5 11.3261 5.52678 12.5979 6.46447 13.5355C7.40215 14.4732 8.67392 15 10 15C11.3261 15 12.5979 14.4732 13.5355 13.5355C14.4732 12.5979 15 11.3261 15 10C15 8.67392 14.4732 7.40215 13.5355 6.46447C12.5979 5.52678 11.3261 5 10 5ZM16.5 4.75C16.5 4.41848 16.3683 4.10054 16.1339 3.86612C15.8995 3.6317 15.5815 3.5 15.25 3.5C14.9185 3.5 14.6005 3.6317 14.3661 3.86612C14.1317 4.10054 14 4.41848 14 4.75C14 5.08152 14.1317 5.39946 14.3661 5.63388C14.6005 5.8683 14.9185 6 15.25 6C15.5815 6 15.8995 5.8683 16.1339 5.63388C16.3683 5.39946 16.5 5.08152 16.5 4.75ZM10 7C10.7956 7 11.5587 7.31607 12.1213 7.87868C12.6839 8.44129 13 9.20435 13 10C13 10.7956 12.6839 11.5587 12.1213 12.1213C11.5587 12.6839 10.7956 13 10 13C9.20435 13 8.44129 12.6839 7.87868 12.1213C7.31607 11.5587 7 10.7956 7 10C7 9.20435 7.31607 8.44129 7.87868 7.87868C8.44129 7.31607 9.20435 7 10 7Z"
            fill="#607B96"
          />
        </svg>
      ),
      url: "",
    },
  ];
  function openUrlInNewTab(url: string): void {
    const newTab = window.open(url, "_blank");
    newTab?.focus();
  }
  return (
    <div className="footer-container">
      <div className="footer-container__find-me">
        <div className="footer-container__find-me__title">find me in:</div>
        {social.map((item) => (
          <div
            key={item.id}
            className="footer-container__find-me__icon"
            onClick={() => openUrlInNewTab(item.url)}
          >
            {item.icon}
          </div>
        ))}
      </div>
      <div
        className="footer-container__git-username"
        onClick={() => openUrlInNewTab("https://github.com/hamzarihani")}
      >
        <span>@hamzarihani</span>
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.9771 0.278076C5.45205 0.278076 0.977052 4.75308 0.977052 10.2781C0.975918 12.3774 1.63587 14.4237 2.86327 16.1268C4.09067 17.8298 5.8232 19.1031 7.81505 19.7661C8.31505 19.8531 8.50205 19.5531 8.50205 19.2901C8.50205 19.0531 8.48905 18.2661 8.48905 17.4281C5.97705 17.8911 5.32705 16.8161 5.12705 16.2531C5.01405 15.9651 4.52705 15.0781 4.10205 14.8401C3.75205 14.6531 3.25205 14.1901 4.08905 14.1781C4.87705 14.1651 5.43905 14.9031 5.62705 15.2031C6.52705 16.7151 7.96505 16.2901 8.53905 16.0281C8.62705 15.3781 8.88905 14.9411 9.17705 14.6911C6.95205 14.4411 4.62705 13.5781 4.62705 9.75308C4.62705 8.66508 5.01405 7.76608 5.65205 7.06508C5.55205 6.81508 5.20205 5.79008 5.75205 4.41508C5.75205 4.41508 6.58905 4.15308 8.50205 5.44108C9.31611 5.21514 10.1572 5.10142 11.0021 5.10308C11.8521 5.10308 12.7021 5.21508 13.5021 5.44008C15.4141 4.14008 16.2521 4.41608 16.2521 4.41608C16.8021 5.79108 16.4521 6.81608 16.3521 7.06608C16.9891 7.76608 17.3771 8.65308 17.3771 9.75308C17.3771 13.5911 15.0401 14.4411 12.8151 14.6911C13.1771 15.0031 13.4901 15.6031 13.4901 16.5411C13.4901 17.8781 13.4771 18.9531 13.4771 19.2911C13.4771 19.5531 13.6651 19.8651 14.1651 19.7651C16.1501 19.0949 17.875 17.8191 19.097 16.1172C20.3189 14.4154 20.9765 12.3732 20.9771 10.2781C20.9771 4.75308 16.5021 0.278076 10.9771 0.278076Z"
            fill="#607B96"
          />
        </svg>
      </div>
    </div>
  );
}

export default Footer;
